(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("fusioncharts"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "fusioncharts"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jquery"), require("fusioncharts")) : factory(root["jquery"], root["fusioncharts"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 